import { SVG, SVGProps } from './svg'

export function IconCandleBarHollow(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 30 30">
      <path d="M14 3h1v5h3v14h-3v5h-1v-5h-3V8h3V3Zm3 6h-5v12h5V9Z" />
    </SVG>
  )
}
